import { put, select, takeEvery, call } from 'redux-saga/effects';
import { addUserImageToCanvas, UPLOAD_IMAGE_FILES } from 'JS/actionCreators/imagesActions';
import { showError } from 'JS/actionCreators/uiActions';
import { ALLOWED_IMAGE_TYPES, canvasSizes } from 'JS/config/defaults';
import processImageForUpload from 'JS/sagas/sagaHelpers/processImageForUpload';

import { getScribeById } from './selectors';

export const MAX_SIMULTANEOUS_FILE_UPLOAD = 5;

export function* uploadImageFiles({ scribeId, files, uploadMethod }) {
  if (files.length > MAX_SIMULTANEOUS_FILE_UPLOAD) {
    return yield put(
      showError({
        message: resx('image-browse-upload-max-exceeded'),
        description: resx('image-browse-upload-more-than-5-images')
      })
    );
  }

  const filesToProcess = Array.from(files).filter(file => ALLOWED_IMAGE_TYPES.includes(file.type));
  const showSomeFilesIncompatibleError = filesToProcess.length !== files.length;

  if (showSomeFilesIncompatibleError) {
    yield put(
      showError({
        message: 'Some of your files contained incompatible file types',
        description: 'These files were not added to your project'
      })
    );
  }

  const scribe = yield select(getScribeById, scribeId);
  const canvasSize = canvasSizes[scribe.canvasSize];

  for (const file of filesToProcess) {
    try {
      const { file: processedFile, name } = yield call(processImageForUpload, file);
      yield put(addUserImageToCanvas(processedFile, name, scribeId, canvasSize, uploadMethod));
    } catch (error) {
      yield put(
        showError({
          message: 'One of your files failed to upload',
          description: error.message
        })
      );
    }
  }
}

export default function* imageUploadSagas() {
  yield takeEvery(UPLOAD_IMAGE_FILES, uploadImageFiles);
}
